import type { PageLoad } from './$types'

export const load: PageLoad = async () => {
	const title = `Explore Travel Guides | Airheart`
	const description = `Your marketplace for digital travel guides`

	return {
		title,
		description,
		requiresAuthentication: false,
		blockBanner: true,
		layoutType: 'itinerary'
	}
}
